<template>
  <div class="content">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <div>
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="row">
                    <div class="col-md-6 text-muted">
                      Page {{ tagsPagination.page }} / {{ tagsPagination.pages }}
                      - {{ tagsPagination.total }} élément(s)
                    </div>
                    <div class="col-md-6 text-right">
                      <a href @click.prevent="filters.display = !filters.display; setPage(1)" class="btn btn-info m-r-10">
                        <i class="fa fa-filter"></i>
                        Filtrer
                      </a>
                      <a href @click.prevent="createTag()" class="btn btn-default">
                        <i class="fa fa-plus"></i>
                        Ajouter un tag
                      </a>
                    </div>
                  </div>
                </div>
                <div class="card-body table-responsive">
                  <el-form @submit.native.prevent v-if="filters.display">
                    <el-form-item>
                      <el-input
                        @input="setPage(1)"
                        v-model="filters.term"
                        placeholder="Filtrer par mots clés (intitulé)"></el-input>
                    </el-form-item>
                    <div class="row">
                      <div class="col-md-6">
                        <el-form-item>
                          <el-select
                            clearable
                            @change="setPage(1)"
                            v-model="filters.schemes"
                            placeholder="Filtrer par type">
                            <el-option
                              v-for="item in constants.TAG_SCHEMES"
                              :label="$t(`${item}`)"
                              :key="item"
                              :value="item">
                                {{ $t(`${item}`) }}
                            </el-option>
                          </el-select>
                        </el-form-item>

                      </div>
                      <div class="col-md-6">
                        <el-form-item>
                          <el-select
                            clearable
                            placeholder="Filtrer par statut"
                            @change="setPage(1)"
                            v-model="filters.status">
                            <el-option
                              v-for="item in constants.TAG_STATUSES"
                              :label="$t(`${item}`)"
                              :key="item"
                              :value="item">
                                {{ $t(`${item}`) }}
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </div>
                  </el-form>
                  <table
                  v-loading="loading"
                  class="table table-hover">
                      <tbody>
                        <tr
                          @click="toTag(tag.id)"
                          v-for="tag in tags"
                          class="pointer">
                          <td>
                            <h5 class="m-b-10" :class="{'text-muted': !tag.label}">
                              <i class="fa fa-tag"></i>
                              <span v-if="tag.scheme" class="text-muted">
                                {{ tag.scheme | translate }} /
                              </span>
                              {{ tag.label || 'Non précisé' }}
                              <span
                                v-if="tag.status == 'DISABLED'"
                                class="badge badge-danger">Désactivé</span>
                              <br>
                              <small>
                                {{ tag.created_at |  fromNowDate }}
                                - {{ tag.stories_usage_count }} article(s) associé(s)
                              </small>
                            </h5>
                          </td>
                        </tr>
                      </tbody>
                  </table>
                  <hr class="m-t-10">
                  <div class="text-center">
                    <el-pagination
                      @size-change="setPage"
                      @current-change="setPage"
                      :page-size="tagsPagination.par_page"
                      :pager-count="5"
                      :page-count="tagsPagination.pages"
                      :page-sizes="[8, 16, 24, 50, 100]"
                      :current-page="tagsPagination.page"
                      layout="total, prev, pager, next">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- <pre>{{ tags }}</pre> -->
    <!-- <pre>{{ constants }}</pre> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  computed: {
      ...mapGetters({
      constants: 'constants',
      tags: 'tags',
      tag: 'tag',
      tagsPagination: 'tagsPagination'
    }),
  },
  components: {
    VueTagsInput,
  },
  data () {
    return {
      loading: false,
      debounce: null,
      default_filters: null,
      filters: {
        status: null,
        term: null,
        schemes: null,
        page: 1,
        per_page: 25,
        display: false
      },
      mask: 'id,status,label,scheme,stories_usage_count,created_at'
    }
  },
  watch: {
    '$route' (to, from) {
      this.filters = Object.assign(this.filters, to.query)
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.loading = true
      if (this.default_filters === null) {
        this.default_filters = Object.assign({}, this.filters)
      }
      this.filters = Object.assign(this.filters, this.$route.query)
      this.$store.dispatch('getConstants', {
        params: {
          'keys': 'TAG_STATUSES,TAG_SCHEMES',
        }
      })
      this.$store.dispatch('getTags', {
        params: this.filters,
        headers: { 'x-fields': this.mask }
      }).then(() => {
        this.loading = false
      })
    },
    createTag () {
      this.$store.dispatch('createTag', {label: '', sheme: 'story_tag'}).then(() => {
        this.$router.replace({
          name: 'tag',
          params: {id: this.tag.id, edit: true}
        })
      })
    },
    toTag (authorId) {
      this.$router.push({
        name: 'tag',
        params: {id: authorId}
      })
    },
    setPage (page) {
      if (this.filters.display === false && this.default_filters) {
        this.filters = Object.assign({}, this.default_filters)
      }
      this.filters.page = page
      this.$router.replace({
        name: 'tags',
        query: Object.assign({}, this.filters)
      })
      window.scrollTo(0,0)
    }
  }
}
</script>
<style>
</style>
